const PAGE_BASE_TITLE = 'Wiki';

export function getPageTitle(pageTitle?: string) {
    return pageTitle ? `${pageTitle} | ${PAGE_BASE_TITLE}` : PAGE_BASE_TITLE;
}
